import mentoriaApi from './axiosTokenMiddleware';

const mentoriaFinancieraURL = process.env.REACT_APP_MENTORIA_FINANCIERA_URL || "";
const mentoriaFinancieraApiKey =	process.env.REACT_APP_MENTORIA_FINANCIERA_API_KEY || "";

export const getUserState = () => {
	return mentoriaApi.get(mentoriaFinancieraURL + 'getCurrentStateByUser', {
		headers: {
			"ApiKey": mentoriaFinancieraApiKey,
			"Content-Type": "application/json"
		},
	});
};
